import React from 'react';
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';


interface LatLng {
  lat: number;
  lng: number;
}

interface RenderMapsProps {
  center: LatLng;
  containerStyle: Record<string, string>;
}

const RenderMaps = (props: RenderMapsProps) => {
  const { center, containerStyle } = props;
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'render-job-map',
    googleMapsApiKey: process.env.NEXT_PUBLIC_APP_GOOGLE_MAP_KEY ?? '',
  });
  if (loadError) {
    return <div>Map cannot be loaded right now</div>;
  }
  if (!isLoaded) {
    return <div>Loading maps...</div>;
  }

  return isLoaded ? (
    <GoogleMap
      center={center}
      mapContainerStyle={containerStyle}
      zoom={13}
      options={{
        zoomControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
      }}
    >
      <Marker
        position={center}
      />
    </GoogleMap>
  ) : null;
};

export default React.memo(RenderMaps);
